module.exports = __webpack_public_path__ + "img/BSpace-putin.87a0d07e.png";